export default {
  parts: ['header'],
  baseStyle: {
    header: {
      borderBottomWidth: 0,
      fontWeight: 'bold',
      pb: 0,
    },
    content: {
      borderRadius: 3,
      borderColor: 'gray.400',
      boxShadow:
        '0 2px 4px 0 rgb(34 36 38 / 12%), 0 2px 10px 0 rgb(34 36 38 / 15%)',
      _focus: {
        outline: 0,
        boxShadow: 0,
      },
      '--popper-arrow-shadow-color': '#A0AEC0', // gray.400
    },
    body: {
      pt: 0,
    },
  },
}
